import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { IoFilterSharp } from "react-icons/io5";
import { FaChevronDown, FaChevronLeft } from "react-icons/fa";

export default function FilterDropdown({ filters, CustomMultiValue }) {
    const [activeSubmenu, setActiveSubmenu] = useState(null);

    return (
        <Dropdown autoClose="outside">
            <Dropdown.Toggle className="filter-toggle d-flex justify-content-between align-items-center">
                <IoFilterSharp style={{ marginRight: 4 }} /> Filtres{" "}
                <FaChevronDown size={10} style={{ marginLeft: 8 }} />
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ minWidth: "250px", position: "relative" }}>
                {filters.map((filter, idx) => (
                    <Dropdown.Item
                        key={idx}
                        onMouseEnter={() => setActiveSubmenu(filter.key)}
                        onMouseLeave={() => setActiveSubmenu(null)}
                        className="d-flex justify-content-between align-items-center position-relative"
                    >
                        <div className="filter-item">
                            <FaChevronLeft size={10} /> {filter.label}
                        </div>

                        {activeSubmenu === filter.key && (
                            <div
                                onMouseEnter={() => setActiveSubmenu(filter.key)}
                                onMouseLeave={() => setActiveSubmenu(null)}
                                className={`submenu ${filter.submenuClass || ""}`}
                            >
                                {/* Render different filter types */}
                                {filter.type === "select" && (
                                    <div className="filter-item mid">
                                        <Select
                                            placeholder={filter.placeholder}
                                            style={{ width: "100%" }}
                                            options={filter.options}
                                            isMulti={filter.isMulti}
                                            components={{ MultiValue: CustomMultiValue }}
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: "100%",
                                                }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    minHeight: "36px",
                                                    right: "190px"
                                                }),
                                            }}
                                            closeMenuOnSelect={false}
                                            value={filter.state}
                                            onChange={(opts) => {
                                                filter.setter(opts);
                                                if (filter.extraOnChange) filter.extraOnChange(opts);
                                            }}
                                        />
                                    </div>
                                )}

                                {filter.type === "date" && (
                                    <>
                                        <div>Date de début:</div>
                                        <DatePicker
                                            wrapperClassName="date-picker"
                                            selected={filter.state.start}
                                            onChange={(date) => filter.setter({ ...filter.state, start: date })}
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Sélectionner une date"
                                        />
                                        <div className="mt-2">Date de fin:</div>
                                        <DatePicker
                                            selected={filter.state.end}
                                            onChange={(date) => filter.setter({ ...filter.state, end: date })}
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Sélectionner une date"
                                        />
                                    </>
                                )}

                                {filter.type === "toggle" && (
                                    <Button
                                        variant={filter.state ? "primary" : "outline-primary"}
                                        onClick={() => filter.setter(!filter.state)}
                                    >
                                        {filter.state ? filter.labels.on : filter.labels.off}
                                    </Button>
                                )}

                                {filter.type === "buttons" && (
                                    <>
                                        {filter.options.map((opt) => (
                                            <Button
                                                key={opt.value}
                                                variant={filter.state === opt.value ? "primary" : "outline-primary"}
                                                onClick={() => filter.setter(opt.value)}
                                                className="me-2"
                                            >
                                                {opt.label}
                                            </Button>
                                        ))}
                                    </>
                                )}
                            </div>
                        )}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}
